import React from 'react';
import { ModuleInterface } from '_iae/module/module';
import { NavItem } from 're-cy-cle';
import { t } from 'i18next';
import ProjectOverview from './ProjectOverview';
import ProjectDetailOverview from './ProjectDetailOverview';
import MilestoneDetailOverview from './MilestoneDetailOverview';
import DeveloperOverview from './DeveloperOverview';
import DeveloperScheduleView from './DeveloperScheduleView';
import SprintBoard from './SprintBoard';
import TimeRegistrationHistory from './TimeRegistrationHistory';
import MilestoneStatusOverview from './MilestoneStatusOverview';

export const planningModule: ModuleInterface = {
    name: 'planning',
    navigationMenu: () => ({
        basePath: '/planning/project/overview/',
        topMenuItem: (
            <NavItem
                title={t('nav.planning.projectOverview', 'Project Overview')}
                to="/planning/project/overview"
                activePath="/planning/project"
                data-test-nav="project-overview"
            />
        ),
        subMenuItems: [
            <NavItem
                key="developer"
                title={t('nav.planning.developerOverview', 'Developer Overview')}
                to="/planning/developer/overview"
                activePath="/planning/developer"
                data-test-nav="developer-overview"
            />,
            <NavItem
                key="developer-schedule"
                title={t('nav.planning.developerSchedule', 'My Schedule')}
                to="/planning/developer/schedule"
                activePath="/planning/developer/schedule"
                data-test-nav="developer-schedule"
            />,
            <NavItem
                key="sprint-board"
                title={t('nav.planning.sprintBoard', 'Sprint Board')}
                to="/planning/sprint/board"
                activePath="/planning/sprint"
                data-test-nav="sprint-board"
            />,
            <NavItem
                key="time-history"
                title={t('nav.planning.timeHistory', 'Time History')}
                to="/planning/time/history"
                activePath="/planning/time"
                data-test-nav="time-history"
            />,
        ]
    }),
    routes: [
        { path: '/planning/project/overview', screen: ProjectOverview },
        { path: '/planning/project/:id/overview', screen: ProjectDetailOverview },
        { path: '/planning/milestone/:id/overview', screen: MilestoneDetailOverview },
        { path: '/planning/milestone/:id/status', screen: MilestoneStatusOverview },
        { path: '/planning/developer/overview', screen: DeveloperOverview },
        { path: '/planning/developer/schedule', screen: DeveloperScheduleView },
        { path: '/planning/sprint/board', screen: SprintBoard },
        { path: '/planning/time/history', screen: TimeRegistrationHistory },
    ],
    translations: {
        en: {},
        nl: {}
    }
};
